"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.borderStyles = void 0;
const borderStyles = {
  solid: 'solid'
};
exports.borderStyles = borderStyles;